import trackGAEvent from './analytics/trackGAEvent';

var setupLinkGAClickTracking = function setupLinkGAClickTracking() {
  var trackLinks = document.querySelectorAll('a[data-track-click-event]');
  trackLinks.forEach(function (link) {
    var eventName = link.dataset.trackClickEvent;
    var eventCategory = link.dataset.trackClickEventCategory;
    var eventLabel = link.dataset.trackClickEventLabel;
    link.addEventListener('click', function () {
      trackGAEvent({
        action: eventName,
        category: eventCategory,
        label: eventLabel
      });
    });
  });
};

export default setupLinkGAClickTracking;